module.exports = __webpack_public_path__ + "5233158ba15908ca6df29d16e791dfa2.png";